import { Link } from "react-router-dom";
import { gossipTopics } from "@/mocks/gossipTopics";
import { formatHeat } from "@/utils/format";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line",
  down: "ri-arrow-down-line",
  new: "ri-flashlight-fill",
};

const trendClass: Record<string, string> = {
  up: "text-primary-600",
  down: "text-accent-600",
  new: "text-secondary-600",
};

interface HotRankingProps {
  limit?: number;
}

export default function HotRanking({ limit = 10 }: HotRankingProps) {
  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
      <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-fire-fill text-primary-500" />
          热搜榜
        </h2>
        <span className="flex items-center gap-1.5 text-xs text-foreground-500">
          <span className="live-dot inline-block h-1.5 w-1.5 rounded-full bg-primary-500" />
          实时更新
        </span>
      </div>
      <ol className="divide-y divide-background-200">
        {gossipTopics.slice(0, limit).map((topic) => (
          <li key={topic.rank}>
            <Link
              to={`/category/${topic.categorySlug}`}
              className="flex items-start gap-3 px-5 py-3.5 transition-colors hover:bg-background-50"
            >
              <span
                className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-label text-xs font-bold ${
                  topic.rank <= 3 ? "bg-primary-500 text-background-50" : "bg-background-300 text-foreground-700"
                }`}
              >
                {topic.rank}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm leading-snug text-foreground-900">{topic.title}</span>
                <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                  <i className={`${trendIcon[topic.trend]} ${trendClass[topic.trend]}`} />
                  {formatHeat(topic.heat)} 热度
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}